/* eslint-disable @typescript-eslint/no-empty-function */
import Action from 'ageas-react-component-action'
import MainLoader from 'ageas-react-component-loader'
import Modal from 'ageas-react-component-modal'
import PageTitle from 'ageas-react-component-pagetitle'
import TextField from 'ageas-react-component-textfield'
import IBAN from 'iban'
import { useCallback, useEffect, useState } from 'react'
import { ModalComponent } from '../../Components/ModalComponent'
import { usePaymentStore } from '../../Stores/paymentStore'
import { useWarningStore } from '../../Stores/warningStore'
import { WARNING_BAR } from '../../constants/warningBar'
import { useEstablishEntityIbans } from '../../hooks/api/establishEntityIbans/useEstablishEntityIbans'
import { useEstablishEntityIbansPayload } from '../../hooks/api/establishEntityIbans/useEstablishEntityIbansPayload'
import { t } from '../../i18n'

type AddNibProps = {
  isVisible: boolean
  closeAction?: () => void
}

export const AddNib = ({ isVisible, closeAction = () => {} }: AddNibProps) => {
  const { setSelectedIBAN, setNewIban, addedIbanList } = usePaymentStore()
  const { setWarningOptions } = useWarningStore()
  const [validIBAN, setValidIBAN] = useState('A')
  const [currentIban, setCurrentIban] = useState('PT50')
  const [isIbanValid, setIsIbanValid] = useState(false)
  const [messageIBAN, setMessageIBAN] = useState<string>('')

  const { handleEstablishEntityIbansPayload } = useEstablishEntityIbansPayload()
  const {
    data: establishEntityIbansData,
    mutate: establishEntityIbansMutate,
    isLoading: establishEntityIbansIsLoading,
    isSuccess: establishEntityIbansIsSuccess,
  } = useEstablishEntityIbans()

  const handleSubmitNewIban = () => {
    establishEntityIbansMutate(handleEstablishEntityIbansPayload(validIBAN))
  }

  const validateIban = (iban: string) => {
    if (IBAN.isValid(iban)) {
      setValidIBAN(iban)
      setCurrentIban(iban)
      setIsIbanValid(true)
      setMessageIBAN('')
      return
    } else {
      setMessageIBAN(t('pages.step6.errors.invalidIban'))
      setValidIBAN('A')
      setIsIbanValid(false)
      return
    }
  }

  const resetValues = () => {
    setValidIBAN('A')
    setIsIbanValid(false)
    setMessageIBAN('')
    setCurrentIban('PT50')
  }

  const handleSubmitNewIbanSuccess = useCallback(() => {
    setSelectedIBAN(validIBAN)
    if (addedIbanList.includes(validIBAN)) {
      setWarningOptions({
        type: WARNING_BAR.type.warning,
        labelTypes: [t('pages.step6.errors.warning')],
      })
      return
    }
    setNewIban(validIBAN)
    setIsIbanValid(false)
    resetValues()
    closeAction()
  }, [addedIbanList, validIBAN])

  useEffect(() => {
    if (establishEntityIbansIsSuccess) {
      if (establishEntityIbansData.valid) {
        handleSubmitNewIbanSuccess()
      } else {
        setIsIbanValid(false)
        setMessageIBAN(
          'O IBAN introduzido está condicionado devido a regras de validação',
        )
      }
    }
  }, [establishEntityIbansIsSuccess, establishEntityIbansData])

  useEffect(() => {
    return () => {
      resetValues()
    }
  }, [])

  return (
    <>
      <MainLoader show={establishEntityIbansIsLoading} />
      <ModalComponent show={isVisible}>
        <Modal
          show={isVisible}
          hideCloseAction={false}
          closeAction={closeAction}
          content={
            <>
              <PageTitle id="nibEntity" name={t('pages.step6.addBank')} />
              <TextField
                id={`PT50-${currentIban}`}
                name="NIB"
                required={true}
                label={t('pages.step6.addIBAN')}
                value={currentIban}
                key={`PT50-${currentIban}`}
                message={messageIBAN}
                formatErrorMessage={messageIBAN}
                validation={validIBAN}
                mask="PT#######################"
                colorTheme="blue"
                version="2"
                onValueChanged={(id: any, value: any, valid: any) => {
                  validateIban(value)
                }}
              />
              <Action
                id="nibCreate"
                disable={!isIbanValid || establishEntityIbansIsLoading}
                label={t('general.nextAction')}
                type="button"
                onValueChanged={handleSubmitNewIban}
              />
            </>
          }
        />
      </ModalComponent>
    </>
  )
}
